/**
 * @generated SignedSource<<a4c40cf49c9ec2485ccdabc28feb2530>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsHeader_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedNewSellerPill_viewer">;
  readonly " $fragmentType": "PdpSharedDealerDetailsHeader_viewer";
};
export type PdpSharedDealerDetailsHeader_viewer$key = {
  readonly " $data"?: PdpSharedDealerDetailsHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerDetailsHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDetailsHeader_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedNewSellerPill_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "94c178b85e04a498d83b4d4dfda6273d";

export default node;
